// extracted by mini-css-extract-plugin
export default {"Dialog":"infodialog_Dialog__o9icL","Close":"infodialog_Close__Mebd2","Body":"infodialog_Body__M3S3p","Title":"infodialog_Title__VAVAg","Text":"infodialog_Text__kZA8v"};